import { useState } from 'react'

import { Alert, Box, FormControl, FormControlLabel, Grid, Slider, Typography } from '@mui/material'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import useLocale from '../../../utils/locale/locale.hook'

const marks = [
    {
        value: 10,
        label: '10°C',
    },
    {
        value: 15,
        label: '15°C',
    },
    {
        value: 20,
        label: '20°C',
    },
    {
        value: 25,
        label: '25°C',
    },
]

const SiteTelecommand = ({ addModification, style }) => {
    const [tempOrder, setTempOrder] = useState(null)
    const [drive, setDrive] = useState(null)
    const locale = useLocale()
    return (
        <>
            <Alert severity="warning">{locale?.['realTime']?.['siteWarning']}</Alert>
            <Grid container spacing={2} style={{ ...style }}>
                <Grid item xs={12} md={4}>
                    <FormControl
                        onChange={(e) => {
                            let value = e.target.value
                            setDrive(value)
                            addModification(0, value === 'on' ? 1 : 0, 'drive', null)
                        }}
                    >
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            //defaultValue="female"
                            name="radio-buttons-group"
                        >
                            <FormControlLabel value="on" control={<Radio />} label={locale?.['realTime']?.['allOn']} />
                            <FormControlLabel
                                value="off"
                                control={<Radio />}
                                label={locale?.['realTime']?.['allOff']}
                            />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item md={4} xs={12}>
                    {/* <TemperatureInput
            min={14}
            max={27}
            onChange={(value) => {
              setTempOrder(value);
              addModification(0, value, "tempOrder");
            }}
            value={tempOrder || ""}
            unit={"°C"}
            label={locale?.["realTime"]?.["order"]}
            placeholder="20"
          /> */}
                    <Box sx={{ padding: { xs: '10px', sm: 0 } }}>
                        <Typography id="input-slider" gutterBottom>
                            Température demandée
                        </Typography>
                        <Slider
                            aria-label="Small steps"
                            //defaultValue={0.00000005}
                            valueLabelFormat={(val, index) => `${val}°C`}
                            step={1}
                            min={10}
                            max={25}
                            valueLabelDisplay="auto"
                            marks={marks}
                            onChange={(e) => {
                                setTempOrder(e.target.value)
                                addModification(0, e.target.value, 'tempOrder', null)
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default SiteTelecommand
